export interface ILead {
    city: string;
    company_name: string;
    contactno: string;
    create_date: string;
    email: string;
    fname: string;
    status: string;
}
export class UserSetting {
    public static firstTimeUser: boolean = false;
    public static reset() {
        UserSetting.userName = "";
        UserSetting.userName = "";
        UserSetting.userProfilePicture = "";
        UserSetting.userBDPEmail = "";
        UserSetting.userWorkEmail = "";
        UserSetting.companyName = "";
        UserSetting.companyPhone = "";
        UserSetting.companyAddress = "";
    }
    public static userName: string;
    // public static userLastName:string;
    public static userProfilePicture: string;
    public static userBDPEmail: string;
    public static userWorkEmail: string;
    public static companyName: string;
    public static companyPhone: string;
    public static companyAddress: string;
}
